export const TYPE_STANDARD = 'standard';
export const TYPE_COMPACT = 'compact';
